import type {
  AmsPartModel,
  AmsPartsFilterProps,
  BulkAmsPartValidationRow,
  CreateAmsPartBulkBody,
  CreateAmsPartParams,
  DeleteAmsPartParams,
  ListAmsPartsResponse,
  UpdateAmsPartParams
} from '../types';
import { apiDel, apiGet, apiPost, apiPut } from './api-client';
import { PaginationParams } from './params';

const apiName = 'avaniV2HttpApi';
const path = 'outer/ams-parts';

export const listAmsParts = async (
  filters: AmsPartsFilterProps,
  params: PaginationParams = new PaginationParams()
): Promise<ListAmsPartsResponse> => {
  const { brewer, mainCategory, type } = filters;
  return apiGet(apiName, path, {
    ...(brewer && { brewerId: brewer.id }),
    ...(mainCategory && { mainCategory }),
    ...(type && { type }),
    ...params
  });
};

export const getAmsPartInfo = async (amsPartId: string): Promise<AmsPartModel> => {
  return apiGet(apiName, `${path}/${amsPartId}`);
};

export const createAmsPart = async (body: CreateAmsPartParams): Promise<AmsPartModel> => {
  return apiPost(apiName, path, body);
};

export const updateAmsPart = async (params: UpdateAmsPartParams): Promise<AmsPartModel> => {
  const { amsPartId } = params;
  return apiPut(apiName, `${path}/${amsPartId}`, { ...params });
};

export const deleteAmsPart = async (params: DeleteAmsPartParams): Promise<AmsPartModel> => {
  return apiDel(apiName, `${path}/${params.amsPartId}`);
};

export const listAmsPartsAutoComplete = async (
  search: string,
  brewerId: string
): Promise<ListAutoCompleteAmsPartsResponse> => {
  return apiGet(apiName, `${path}/autocomplete`, { search, brewerId, sortBy: 'type' });
};

export interface ListAutoCompleteAmsPartsResponse {
  result: AmsPartModel[];
  count: number;
}

export const validateAmsPartBulkCsv = async (file: File): Promise<BulkAmsPartValidationRow[]> => {
  const formData = new FormData();
  formData.append('file', file);
  return apiPost(apiName, `${path}/bulk-csv`, formData);
};

export const createAmsPartBulk = async (
  body: CreateAmsPartBulkBody
): Promise<{ success?: string; errors?: string[] }> => {
  return apiPost(apiName, `${path}/bulk`, body);
};
